import styled from 'styled-components';

export const MainBlock = styled.div`
  margin: 0 10px;
  min-height: 50px;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: flex-end;
`;

export const Points = styled.span`
  font-size: xx-large;
`;

export const Title = styled.span`
  padding: 10px;
`;
